
export const CLEAR_MESSAGE ="CLEAR_MESSAGE";
/*********************** CATEGORY ************************/
export const GET_CATEGORIES = "GET_CATEGORIES";
export const POST_CATEGORY = "POST_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
/*********************** SUBCATEGORY ************************/
export const GET_PAGE_TYPE_OPTIONS ="GET_PAGE_TYPE_OPTIONS";
export const GET_SUBCATEGORY_BY_ID = "GET_SUBCATEGORY_BY_ID";
export const CLEAR_SUBCATEGORIES ="CLEAR_SUBCATEGORIES";
export const POST_SUBCATEGORY = "POST_SUBCATEGORY";
export const UPDATE_SUBCATEGORY = "UPDATE_SUBCATEGORY";
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY";
/******************************** AFFECTATION  ********************************/
export const GET_CATEGORIES_TO_ADD = "GET_CATEGORIES_TO_ADD";
export const GET_SITE_CATEGORIES= "GET_SITE_CATEGORIES";
export const DELETE_SITE_CAT ="DELETE_SITE_CAT";
export const ADD_SITE_CAT ="ADD_SITE_CAT";

/********************Patch category***********************/
export const PATCH_CATEGORY = "PATCH_CATEGORY";
